import { css } from '@emotion/css';
import { Display, Spacing } from 'src/styles';

export const container = css`
  ${Display.flex}
  ${Spacing.my12}
`;
